// @Version: 1.0.0
export enum FC_COMBOFIELD {
   COMBOFIELD = "combofield" 
}